export const en = {
	'Тарифы': 'Tariffs',
	'Заявка на смену тарифа принята': 'Top up application accepted',
	'Наш менеджер свяжется с вами в скором времени.': 'Our manager will contact you shortly. A bill of payment will be available in your account.',
	'Хорошо': 'Ok'
};
